// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"32":"d6f60713","233":"90dd7bd6","255":"68012c9b","573":"bf3d77c4","828":"be8f9ca6","948":"183759a5"}[chunkId] + ".chunk.css";
};